"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttackEventArgs = void 0;
const EventType_1 = require("../EventType");
class AttackEventArgs {
    constructor(targetId, roll, hit, crit) {
        this.targetId = targetId;
        this.roll = roll;
        this.hit = hit;
        this.crit = crit;
        this.__type = EventType_1.EventType.Attack;
        this.__typeName = "Attack";
    }
}
exports.AttackEventArgs = AttackEventArgs;
